import * as types from './constants'
const initialState = {
	orgGroupsLoading: false,
	orgGroups: [],
	orgGroup: null,
	searchValue: '',
	searchValueOnClick: '',
	orgGroupChildren: [],
	filterGroupLocationsValue: '',
}

// eslint-disable-next-line import/no-anonymous-default-export
const orgGroupsReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.RESET_ORG_GROUP:
			return initialState
		case types.SET_ORG_GROUPS:
			return {
				...state,
				orgGroups: action.orgGroups,
			}
		case types.SET_LOADING:
			return {
				...state,
				orgGroupsLoading: action.value,
			}
		case types.SET_ORG_GROUP_SEARCH_VALUE:
			return {
				...state,
				searchValue: action.value,
			}
		case types.SET_SEARCH_VALUE_ON_CLICK:
			return {
				...state,
				searchValueOnClick: action.value,
			}
		case types.SET_ORG_GROUP:
			return {
				...state,
				orgGroup: action.value,
			}
		case types.SET_ORG_GROUP_GROUPS:
			return {
				...state,
				orgGroupChildren: action.value,
			}
		case types.SET_GROUP_LOCATIONS_FILTER_VALUE:
			return {
				...state,
				filterGroupLocationsValue: action.value,
			}
		case types.SET_ORG_GROUP_NAME:
			return {
				...state,
				orgGroup: { ...state.orgGroup, name: action.value },
			}
		default:
			return state
	}
}

export default orgGroupsReducer
